/**
 * Mock User Management Data
 *
 * Convention-based mock exports:
 * - MOCK_GET_ORGANIZATIONS (endpoint: getOrganizations)
 * - MOCK_GET_HUMAN_USER_ROLES (endpoint: getHumanUserRoles)
 * - MOCK_GET_USERS (endpoint: getUsers)
 *
 * This file contains mock data for user management forms and lists.
 * Automatically discovered and used when mock: true is set in apiRoutes.yml
 */

export const MOCK_GET_ORGANIZATIONS = {
  organizations: [
    {
      id: '1',
      organizationName: 'Engineering Team',
    },
    {
      id: '2',
      organizationName: 'Sales Team',
    },
    {
      id: '3',
      organizationName: 'Operations Team',
    },
    {
      id: '4',
      organizationName: 'Marketing Team',
    },
  ],
};

export const MOCK_GET_HUMAN_USER_ROLES = {
  roles: [
    {
      id: '1',
      name: 'Administrator',
    },
    {
      id: '2',
      name: 'Manager',
    },
    {
      id: '3',
      name: 'Team Lead',
    },
    {
      id: '4',
      name: 'Developer',
    },
    {
      id: '5',
      name: 'Analyst',
    },
    {
      id: '6',
      name: 'User',
    },
  ],
};

export const MOCK_GET_USERS = {
  users: [
    {
      id: '1',
      firstName: 'John',
      lastName: 'Doe',
      emailAddress: 'john.doe@example.com',
      jobRole: ['1'],
      organizations: ['1', '2'],
      invitationStatus: 'accepted',
    },
    {
      id: '2',
      firstName: 'Jane',
      lastName: 'Smith',
      emailAddress: 'jane.smith@example.com',
      jobRole: ['2'],
      organizations: ['2'],
      invitationStatus: 'accepted',
    },
    {
      id: '3',
      firstName: 'Bob',
      lastName: 'Johnson',
      emailAddress: 'bob.johnson@example.com',
      jobRole: ['3'],
      organizations: ['1'],
      invitationStatus: 'pending',
    },
  ],
};
